export default (Masonry, imagesLoaded) => {
  Array.from(document.querySelectorAll('.card-container')).forEach((cards) => {
    const cardLayout = new Masonry(cards, {
      itemSelector: '.card',
      transitionDuration: 0
    });
    imagesLoaded(cards, () => {
      cardLayout.layout();
    });
  });
};
